const Footer = () => {
    return (
        <div className="footer">
            <p>Designed & built by Georgii Mamaev</p>
        </div>
    );
}
export default Footer;